import * as types from './types';
import { SITESETUP_CLEAR_FETCHED } from '../types';

const INITIAL_STATE = {
  data: [],
  error: null,
  fetching: false,
  fetched: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SITESETUP_CLEAR_FETCHED:
      return {
        ...state,
        fetched: false,
      };

    case types.SITESETUP_ENROLLMENT_FETCHING:
      return {
        ...state,
        fetching: action.payload,
      };

    case types.SITESETUP_GET_ENROLLMENT_DETAILS:
      return {
        ...state,
        data: action.payload.Data,
        fetched: true,
      };

    case types.SITESETUP_GET_ENROLLMENT_DETAILS_ERROR:
      return {
        ...state,
        data: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/enrollment/reducer.js